import { maskitoTransform } from '@maskito/core';
import { maskitoPhoneOptionsGenerator } from '@maskito/phone';
import metadata from 'libphonenumber-js/min/metadata';
var ANY_COUNTRY_PHONE_MASK = maskitoPhoneOptionsGenerator({ metadata: metadata, strict: false });
var maskPhone = function (value) { return maskitoTransform(value, ANY_COUNTRY_PHONE_MASK); };
export { ANY_COUNTRY_PHONE_MASK, maskPhone };
